import { useMemo } from "react";

import useQuery from "../search/useQuery";
import QUERY_TAGS from "../search/queryTags";
import { TAXONOMY_STALE_TIME } from "../finance/financeCache";
import { normalizeSharedPage } from "../finance/financePage";
import { fetchFaqs, LPG_VERTICAL_ID } from "./faqsService";
import { mapFaqs } from "./faqsMappers";

const useFaqs = ({ verticalId = LPG_VERTICAL_ID, enabled = true } = {}) => {
  const query = useQuery({
    key: `faqs:${verticalId ?? "all"}`,
    tag: QUERY_TAGS.FAQ_LIST,
    staleTime: TAXONOMY_STALE_TIME,
    enabled,
    fetcher: () => fetchFaqs({ verticalId }),
  });

  const items = useMemo(
    () => mapFaqs(normalizeSharedPage(query.currentData).items),
    [query.currentData],
  );

  const hasData = query.currentData !== undefined;

  return {
    items,
    isLoading: !hasData && !query.isError && query.enabled,
    isFetching: query.isFetching,
    isError: query.isError && !hasData,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useFaqs;
